import { create } from 'zustand';
import { UNDERWRITING_STATUS_FILTERS } from '@shared';

interface EligibilityFiltersState {
  selectedEligibilityFilters: string[];
  selectedFeatureBenefitsFilters: string[];
  actions: {
    setSelectedEligibilityFilters: (filters: string[]) => void;
    setSelectedFeatureBenefitsFilters: (filters: string[]) => void;
    removeEligibilityFilter: (filter: string) => void;
    removeFeatureBenefitsFilter: (filter: string) => void;
  };
}

const DEFAULT_ELIGIBILITY_FILTERS = UNDERWRITING_STATUS_FILTERS.map(f => f.value);

export const useEligibilityFiltersStore = create<EligibilityFiltersState>(set => ({
  selectedEligibilityFilters: [...DEFAULT_ELIGIBILITY_FILTERS],
  selectedFeatureBenefitsFilters: [],
  actions: {
    setSelectedEligibilityFilters: filters => set({ selectedEligibilityFilters: filters }),
    setSelectedFeatureBenefitsFilters: filters =>
      set({ selectedFeatureBenefitsFilters: filters }),
    removeEligibilityFilter: filterToRemove =>
      set(state => ({
        selectedEligibilityFilters: state.selectedEligibilityFilters.filter(
          f => f !== filterToRemove,
        ),
      })),
    removeFeatureBenefitsFilter: filterToRemove =>
      set(state => ({
        selectedFeatureBenefitsFilters: state.selectedFeatureBenefitsFilters.filter(
          f => f !== filterToRemove,
        ),
      })),
  },
}));

export const useSelectedEligibilityFilters = () =>
  useEligibilityFiltersStore(state => state.selectedEligibilityFilters);

export const useSelectedFeatureBenefitsFilters = () =>
  useEligibilityFiltersStore(state => state.selectedFeatureBenefitsFilters);

export const useEligibilityFiltersActions = () =>
  useEligibilityFiltersStore(state => state.actions);
